import client, { authHeader } from "./client";

/** 예약 신청 화면의 매장 선택 드롭다운 (회원/비회원 공통, 인증 불필요) */
export async function getStoreOptions() {
  const res = await client.get("/reservation/stores");
  return res.data;
}

// ===================== 회원용 (JWT 필요) =====================

export async function createMemberReservation(payload, accessToken) {
  const res = await client.post("/reservation", payload, { headers: authHeader(accessToken) });
  return res.data;
}

export async function getMyReservations(accessToken) {
  const res = await client.get("/reservation/my", { headers: authHeader(accessToken) });
  return res.data;
}

export async function cancelMyReservation(reservationId, accessToken) {
  const res = await client.put(`/reservation/${reservationId}/cancel`, null, { headers: authHeader(accessToken) });
  return res.data;
}

// ===================== 비회원용 (인증 불필요) =====================

export async function createGuestReservation(payload) {
  const res = await client.post("/reservation/guest", payload);
  return res.data;
}

export async function getGuestReservation(reservationId, phone) {
  const res = await client.get(`/reservation/guest/${reservationId}`, { params: { phone } });
  return res.data;
}

export async function cancelGuestReservation(reservationId, phone) {
  const res = await client.put(`/reservation/guest/${reservationId}/cancel`, { phone });
  return res.data;
}
